var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    role: "img",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "de-circle"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#de-circle)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 10.67,
    y: 0,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 10.67,
    y: 10.67,
    fill: "#DD0000"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 10.66,
    y: 21.34,
    fill: "#FFCE00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDe);
export default __webpack_public_path__ + "static/media/de.2c5a2512203f7ec2e7bc4e30982490f7.svg";
export { ForwardRef as ReactComponent };